import React, {useState, useEffect} from 'react';
import contactValidator from './../contact-validator';
import IsFetchingInline from '../../../common/IsFetchingInline.jsx';

const ContactItem = (props) => {
  let [editMode, setEditMode] = useState(false);
  let [editError, setEditError] = useState(undefined);
  let [account, setAccount] = useState(props.account);

  useEffect(() => {setAccount(props.account)}, [props.account]);

  const updateAccount = (value) => {
    const error = contactValidator(value, props.type);
    if (!error){
      setEditError(undefined);
      setEditMode(false);
      props.onChange(props.contactId, value);
    } else {
      setEditError(error);
    }
  };

  const handleDelete = () => props.onDelete(props.contactId);
  const handleClick = () => setEditMode(true);
  const handleCancel = () => {setEditMode(false);setAccount(props.account);};
  const handleChange = (event) => setAccount(event.currentTarget.value);
  const handleSubmit = () => updateAccount(account);
  const handleKeyDown = (event) => {
    if (event.key === 'Enter'){
      updateAccount(event, account);
    }
  };

  return <div className="d-flex flex-row mb-2 cabinet-editable">
    <div className="flex-column pr-2 font-weight-bold">
        <button type="button"
                className="btn btn-sm btn-outline-light p-0"
                title={gettext('Удалить контакт')}
                onClick={handleDelete}>
          <i className="icon icon-minus"></i>
        </button>
    </div>
    <div className="d-none d-sm-flex flex-column pr-2 font-weight-bold">{props.type_name}:</div>
    <div className="flex-column flex-grow-1">
      {editMode &&
        <div className={editError ? ' was-validate' : ''}>
            <div className="input-group input-group-sm">
              <input type="text"
                     value={account}
                     onChange={handleChange}
                     onKeyDown={handleKeyDown}
                     className={'form-control' + (editError ? ' is-invalid' : '')}
                     autoFocus="true"/>
              <div className="input-group-append">
                <button className={'btn ' + (editError ? 'btn-danger' : 'btn-primary')}
                        type="button"
                        title={gettext('Сохранить')}
                        onMouseDown={handleSubmit}>
                  <i className="icon icon-ok-circled2"></i></button>
                <button className="btn btn-secondary"
                        type="button"
                        title={gettext('Отменить')}
                        onClick={handleCancel}>
                  <i className="icon icon-cancel-circled2"></i></button>
              </div>
              {editError && <span className="invalid-feedback">{editError}</span>}
            </div>
          </div>
      }
      {!editMode && <span className="cabinet-editable__string" title={gettext('Редактировать контакт')} onClick={handleClick}>{props.account_link}</span>}
      <IsFetchingInline isFetching={props.isFetching}/>
    </div>
  </div>
}

export default ContactItem;